import React from 'react';

import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import LocaleIcon from './components/LocaleIcon';
import { ButtonStyled, WrapperStyled } from './styles';
import { AVAILABLE_LOCALE } from '../../constants/i18n';

interface IProps {
  showLabel?: boolean;
}

const LanguageSwitcher = React.memo(({ showLabel = true }: IProps) => {
  const { t, i18n } = useTranslation();

  const handleChange = React.useCallback(
    (event: React.MouseEvent, eventKey: string) => {
      event.stopPropagation();

      i18n.changeLanguage(eventKey);
    },
    [i18n],
  );

  return (
    <WrapperStyled
      isCompact={!showLabel}
      sx={(theme) => ({
        backgroundColor: theme.palette.neutral[100],
        padding: theme.spacing(1),
        borderRadius: theme.spacing(2),
      })}
    >
      {AVAILABLE_LOCALE.map((lang) => (
        <ButtonStyled
          key={`lang-${lang}`}
          onClick={(event) => handleChange(event, lang)}
          variant="contained"
          isActive={i18n.language === lang}
          isCompact={!showLabel}
        >
          <Stack direction="row" spacing={0.5}>
            <LocaleIcon lang={lang} />

            {showLabel && <Typography>{t(`lang.${lang}`)}</Typography>}
          </Stack>
        </ButtonStyled>
      ))}
    </WrapperStyled>
  );
});

export default LanguageSwitcher;
